export default __webpack_public_path__ + "static/media/charging-station.067ca9ff.svg";